import { PopupAction } from '../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../common/scrollComponent'

export const PopupTerms = ({ isShow, handleClose, terms }) => {
  return (
    <PopupAction
      isShow={isShow}
      title="cartAndOrders.orderInformation.ruleLinkTitle"
      handleClose={handleClose}
      appendStyle={{
        width: 1000,
        padding: '20px 20px 8px 20px',
        backgroundColor: '#F3F3F3',
        borderRadius: '4px',
      }}
    >
      <ScrollComponent autoHeight autoHeightMax={700}>
        <div dangerouslySetInnerHTML={{ __html: terms }} />
      </ScrollComponent>
    </PopupAction>
  )
}
